import React from "react";

const PopupTitleCom = ({ title, caption, setOpenPopup }) => {
  return (
    <div className="popupTitleComContainer">
      <div className="popupTitleComTitleSec">
        <div className="popupTitleComTitle">{title}</div>
        <svg
          onClick={() => setOpenPopup(false)}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="#667085"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div className="popupTitleComCaption">{caption}</div>
    </div>
  );
};

export default PopupTitleCom;
